<app-message [service]="messageService"></app-message>

<main>
  <div class="claim">
    <h2 i18n="@@SubcriptionUpgradeHeader">
      Wir haben genau das Richtige für Sie
    </h2>
  
    <p i18n="@@SubcriptionUpgradeText">
      Egal ob Privathaushalt oder Unternehmen, das Lademanagement sollte ganz einfach sein. Deshalb haben wir nicht nur eine Ladestation entwickelt, sondern auch die passende Software dazu.
      <ng-container *ngTemplateOutlet="logo"></ng-container>
    </p>
  </div>

  <div class="features p-4">
    <table>
      <thead class="sticky-top">
        <tr class="feature-package">
          <th class="feature-abonnement-standard" i18n="@@subscriptionTypeStandardLabel">Standard</th>
          <th class="feature-abonnement-premium" i18n="@@subscriptionTypePremiumLabel">Premium</th>
          <th class="feature-abonnement-enterprise" i18n="@@subscriptionTypeEnterpriseLabel">Enterprise</th>
          <th></th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr class="feature-pricing">
          <td class="feature-abonnement-standard" i18n="@@StandardPriceText">
            <span>12&nbsp;€<br></span><small>pro Jahr und inkl.&nbsp;MwSt.</small>
          </td>
          <td class="feature-abonnement-premium" i18n="@@PremiumPriceText">
            <span>36&nbsp;€<br></span><small>pro Jahr und inkl.&nbsp;MwSt.</small>
          </td>
          <td class="feature-abonnement-enterprise" i18n="@@EnterprisePriceText">
            <span>&nbsp;</span><br><small>basierend auf Ihrer Nutzung</small>
            <!-- <span>&nbsp;</span><br><small>auf Anfrage</small> -->
          </td>
          <td></td>
          <td></td>
        </tr>

        <tr *ngFor="let feature of features">
          <td class="feature-abonnement-standard">
            <span *ngIf="feature.abonnements.includes('standard') && !feature.standard; else standardDetail" >
              <ng-container *ngTemplateOutlet="checkIcon"></ng-container>
            </span>
            <ng-template #standardDetail>{{ feature.standard }}</ng-template>
          </td>
          <td class="feature-abonnement-premium">
            <span *ngIf="feature.abonnements.includes('premium') && !feature.premium; else premiumDetail" >
              <ng-container *ngTemplateOutlet="checkIcon"></ng-container>
            </span>
            <ng-template #premiumDetail>{{ feature.premium }}</ng-template>
          </td>
          <td class="feature-abonnement-enterprise">
            <span *ngIf="feature.abonnements.includes('enterprise') && !feature.enterprise; else enterpriseDetail" >
              <ng-container *ngTemplateOutlet="checkIcon"></ng-container>
            </span>
            <ng-template #enterpriseDetail>{{ feature.enterprise }}</ng-template>
          </td>
          <td class="feature-name">{{ feature.name }}</td>
          <td class="feature-description">{{ feature.description }}</td>
        </tr>

        <tr>
          <td class="feature-abonnement-standard">
            <!-- <a class="btn btn-yellow" [routerLink]="['/support']" i18n="@@ContactUs">Anfragen</a> -->
            <a class="btn btn-yellow" i18n="@@PurchaseButton" (click)="subscribeTo('standard')">Kaufen</a>
          </td>
          <td class="feature-abonnement-premium">
            <!-- <a class="btn btn-yellow" [routerLink]="['/support']" i18n="@@ContactUs">Anfragen</a> -->
            <a class="btn btn-yellow" i18n="@@PurchaseButton" (click)="subscribeTo('premium')">Kaufen</a>
          </td>
          <td class="feature-abonnement-enterprise">
            <a class="btn btn-yellow" [routerLink]="['/support']" i18n="@@RequestsButton">Anfragen</a>
            <!-- <a class="btn btn-yellow" [routerLink]="['/support']" i18n="@@ContactUs">Anfragen</a> -->
          </td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <div class="contact">
    <h3 i18n="@@LookForwardContactSupportText">
      Sie haben Fragen oder möchten Kontakt aufnehmen? Wir freuen uns auf Sie.
    </h3>
    <a class="btn btn-yellow" [routerLink]="['/support']" i18n="@@ContactSupport">Kontakt aufnehmen</a>
  </div>

  <!-- <div class="calculator p-4 mt-4">
    <h3 class="mt-4">
      Bezahlen Sie genau das, was Sie brauchen
    </h3>
    <form class="p-4">
      <h3>Was brauchen Sie?</h3>

      <label for="numberOfChargingStations">Ladestationen:
        <input name="numberOfChargingStations" (keyup)="updateNumberOfChargingStations($event.target.value)" [value]="numberOfChargingStations" class="form-control" type="number">
      </label>

      <label for="numberOfUsers">Benutzer:
        <input name="numberOfUsers" (keyup)="updateNumberOfUsers($event.target.value)" [value]="numberOfUsers" class="form-control" type="number">
      </label>

      <label for="numberOfCards">RFID-Karten:
        <input name="numberOfCards" (keyup)="updateNumberOfCards($event.target.value)" [value]="numberOfCards" class="form-control" type="number">
      </label>
      
      <h3><small>Sie zahlen jährlich</small><br>{{ price }}&nbsp;€</h3>
    </form>
  </div> -->
</main>

<ng-template #logo>
  <svg version="1.1" id="logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 2238.7 275.9" style="enable-background:new 0 0 2238.7 275.9;" xml:space="preserve">
    <path id="logo-cubos" style="fill:#768084;" d="M470.8,182.1c1,0,2,0.2,3,0.6c1.1,0.5,2.1,1.1,2.9,2l16.8,17.7
      c-7.2,9.5-16.8,17-27.7,21.8c-11.1,4.9-24.2,7.3-39.4,7.4c-13.9,0-26.4-2.4-37.4-7.1c-10.6-4.5-20.2-11.2-28-19.6
      c-7.8-8.6-13.8-18.7-17.6-29.7c-4.2-12-6.3-24.6-6.2-37.3c-0.2-12.9,2.2-25.7,7-37.6c4.5-11.1,11.2-21.2,19.7-29.6
      c8.7-8.4,18.9-15,30.2-19.3c12.4-4.8,25.6-7.1,38.9-7c6.5,0,13,0.6,19.4,1.8c5.8,1.1,11.5,2.8,17,5c5.1,2.1,10,4.6,14.6,7.7
      c4.3,2.9,8.2,6.2,11.8,9.9L481.5,88c-0.9,1.2-2,2.3-3.3,3.2c-1.5,1.1-3.4,1.6-5.3,1.4c-1.5,0-3-0.3-4.3-1c-1.5-0.7-2.9-1.6-4.3-2.4
      l-5-3.1c-2-1.3-4.2-2.3-6.4-3.2c-2.8-1.1-5.7-1.9-8.7-2.4c-3.8-0.7-7.7-1.1-11.6-1c-7.2-0.1-14.4,1.3-21.1,4.1
      c-6.3,2.6-11.9,6.6-16.4,11.7c-4.7,5.4-8.4,11.6-10.7,18.4c-2.7,7.8-4,16-3.8,24.2c-0.1,8.5,1.2,16.9,3.8,25
      c2.3,6.8,5.8,13,10.5,18.4c4.2,4.9,9.5,8.7,15.4,11.4c5.9,2.6,12.4,3.9,18.9,3.9c3.5,0,7.1-0.2,10.6-0.6c3-0.4,6-1,8.9-2
      c2.7-0.9,5.3-2.1,7.8-3.6c2.7-1.6,5.2-3.4,7.5-5.5c1-0.8,2.1-1.5,3.3-2.1C468.3,182.4,469.6,182.1,470.8,182.1L470.8,182.1z
      M590.9,195.9c5.2,0.1,10.4-0.9,15.3-2.8c4.4-1.8,8.2-4.6,11.4-8.1c3.2-3.8,5.7-8.1,7.1-12.9c1.7-5.6,2.5-11.4,2.5-17.3V46.4h42.5
      v108.5c0.1,10.6-1.7,21-5.5,30.9c-3.5,9.1-8.8,17.4-15.7,24.2c-7.1,7-15.5,12.3-24.8,15.8c-10.5,3.9-21.6,5.8-32.8,5.7
      c-12.2,0-23.2-1.9-32.9-5.7c-9.3-3.5-17.7-8.9-24.8-15.8c-6.9-6.9-12.2-15.2-15.6-24.3c-3.7-9.9-5.5-20.4-5.4-30.9V46.4h42.5v108.3
      c-0.1,5.9,0.7,11.7,2.5,17.3c1.5,4.8,3.9,9.2,7.1,12.9c3.1,3.6,7,6.4,11.4,8.2C580.5,195.1,585.7,196,590.9,195.9L590.9,195.9z
      M702.6,229.5V46.4H770c12.7,0,23.4,1.2,32.3,3.5c8.9,2.3,16.1,5.7,21.7,9.9c5.4,4,9.6,9.4,12.3,15.6c2.6,6.5,3.9,13.5,3.8,20.5
      c0,4-0.6,8-1.8,11.9s-3.1,7.5-5.5,10.8c-2.7,3.5-6,6.6-9.7,9.1c-4.4,3-9.2,5.3-14.2,7.1c12,2.9,21,7.7,26.8,14.3s8.7,15,8.7,25.3
      c0.1,7.5-1.5,14.9-4.5,21.8c-3.1,6.8-7.6,12.7-13.3,17.5c-6.4,5.3-13.7,9.2-21.6,11.7c-9.5,2.9-19.4,4.4-29.3,4.2h-73.1V229.5z
      M745.1,123.4h22.1c4.3,0,8.5-0.3,12.7-1c3.4-0.5,6.7-1.7,9.6-3.5c2.6-1.7,4.7-4.1,6-6.9c1.5-3.5,2.2-7.3,2.1-11.1
      c0.1-3.7-0.4-7.4-1.6-10.9c-1-2.8-2.7-5.2-5-7c-2.5-1.9-5.5-3.2-8.6-3.8c-4.1-0.8-8.2-1.2-12.4-1.1h-24.9L745.1,123.4z M745.1,151.8
      v45.6H775c5.6,0,10.2-0.7,13.8-2.1c3.2-1.2,6-3.1,8.4-5.5c2-2.2,3.4-4.8,4.2-7.7c0.8-2.8,1.1-5.7,1.1-8.7c0-3.1-0.4-6.1-1.3-9.1
      c-0.9-2.6-2.4-5-4.5-6.8c-2.5-2-5.4-3.5-8.5-4.3c-4.4-1.1-8.8-1.6-13.3-1.5L745.1,151.8z M1051.2,137.9c0.1,12.6-2.2,25.2-6.8,36.9
      c-8.8,22.6-26.7,40.6-49.3,49.5c-11.7,4.8-24.7,7.2-38.9,7.2c-13.3,0.2-26.6-2.3-39-7.2c-22.7-8.9-40.6-26.8-49.5-49.5
      c-4.6-11.8-6.9-24.3-6.8-36.9c-0.1-12.7,2.2-25.2,6.8-37c4.4-11.1,11-21.2,19.4-29.7c8.6-8.5,18.8-15.3,30.1-19.7
      c11.7-4.8,24.7-7.2,39-7.2s27.2,2.4,38.9,7.2c11.2,4.5,21.4,11.2,30,19.8c8.3,8.5,14.9,18.6,19.2,29.7
      C1049,112.7,1051.4,125.2,1051.2,137.9z M1007.8,137.9c0.1-8.3-1.1-16.5-3.5-24.4c-2.1-6.8-5.5-13-10.1-18.4c-4.4-5-9.9-9-16.1-11.6
      c-6.9-2.8-14.3-4.1-21.7-4c-7.5-0.1-15,1.2-21.9,4c-6.2,2.5-11.8,6.5-16.2,11.6c-4.6,5.4-8,11.7-10.1,18.4
      c-2.4,7.9-3.6,16.2-3.5,24.4c-0.1,8.3,1.1,16.6,3.5,24.6c2.1,6.8,5.5,13,10.1,18.4c4.4,5,10,9,16.2,11.5c7,2.8,14.4,4.1,21.9,4
      c7.4,0.1,14.8-1.2,21.7-4c6.2-2.5,11.7-6.5,16.2-11.5c4.6-5.4,8-11.7,10.1-18.4C1006.7,154.5,1007.9,146.2,1007.8,137.9
      L1007.8,137.9z M1176.2,83.6c-1,1.7-2.4,3.3-4,4.5c-1.6,1.1-3.4,1.6-5.3,1.5c-2.2-0.1-4.3-0.7-6.2-1.8c-2.2-1.2-4.7-2.6-7.6-4.1
      c-3.1-1.6-6.3-3-9.6-4.1c-4-1.3-8.1-1.9-12.3-1.8c-8,0-13.9,1.7-17.8,5.1s-5.8,8-5.8,13.8c-0.1,3.4,1.2,6.7,3.5,9.2
      c2.7,2.7,5.8,4.8,9.2,6.3c4.2,1.9,8.6,3.5,13.1,4.8c4.9,1.5,9.9,3.1,15,4.9s10.1,3.9,15,6.3c4.8,2.4,9.2,5.5,13.1,9.3
      c3.9,4,7.1,8.6,9.2,13.8c2.3,5.4,3.5,11.9,3.5,19.5c0.1,8.1-1.4,16.2-4.4,23.8c-2.9,7.3-7.2,13.8-12.8,19.3
      c-5.9,5.7-12.9,10.1-20.6,12.9c-8.9,3.3-18.3,4.9-27.8,4.7c-5.8,0-11.7-0.6-17.4-1.8c-5.9-1.2-11.6-2.8-17.2-5
      c-5.4-2.1-10.6-4.6-15.6-7.6c-4.6-2.7-8.9-6-12.7-9.8l12.6-19.9c1-1.5,2.3-2.8,3.9-3.6c1.7-0.9,3.5-1.4,5.4-1.4
      c2.7,0.1,5.3,0.9,7.6,2.4c2.6,1.6,5.5,3.3,8.7,5.3c3.5,2.1,7.3,3.9,11.1,5.3c4.8,1.7,9.8,2.5,14.8,2.4c7.7,0,13.7-1.7,18-5.1
      c4.3-3.4,6.4-8.8,6.4-16.1c0.2-3.8-1.1-7.5-3.5-10.4c-2.6-2.8-5.7-5.1-9.2-6.7c-4.2-1.9-8.5-3.5-13-4.6c-4.9-1.3-9.9-2.8-15-4.5
      c-5.1-1.6-10.2-3.6-15-6s-9.2-5.6-13-9.4c-4-4.2-7.2-9.2-9.2-14.6c-2.4-5.8-3.5-13-3.5-21.6c0-6.9,1.5-13.8,4.3-20.1
      c2.8-6.6,7-12.6,12.2-17.5c5.7-5.3,12.4-9.5,19.7-12.3c8.6-3.2,17.6-4.7,26.8-4.6c5.5,0,11,0.4,16.4,1.3c5.2,0.8,10.2,2.1,15.2,3.9
      c4.6,1.7,9.1,3.7,13.4,6.2c4,2.3,7.7,5,11.1,8.1L1176.2,83.6z"/>
    <path id="logo-signet-outer-right" style="fill:#EE7C00;" d="M199.5,185.1L199.5,185.1L199.5,185.1L146.1,216l-23.4,13.5l0,0l0,0
      v46.3l0,0l117-67.5v-135l-40.1,23.2L199.5,185.1L199.5,185.1z"/>
    <path id="logo-signet-outer-left" style="fill:#F6A500;" d="M40.2,185.1L40.2,185.1L40.2,185.1L93.5,216l23.4,13.5l0,0l0,0v46.3l0,0
      L0,208.3v-135l40.2,23.2V185.1z"/>
    <path id="logo-signet-outer-top" style="fill:#FFCB00;" d="M119.8,46.4l76.8,44.3l40.1-23.2L119.8,0L2.9,67.5L43,90.7L119.8,46.4z"
      />
    <path id="logo-signet-inner-top" style="fill:#D0D5D9;" d="M69.7,106.1L69.7,106.1l50.1,28.9l0,0l50.1-28.9l-50.1-28.9l0,0
      L69.7,106.1L69.7,106.1z"/>
    <path id="logo-signet-inner-right" style="fill:#768084;" d="M122.7,140.8v57.9l50.1-28.9v-57.9L122.7,140.8z"/>
    <path id="logo-signet-inner-left" style="fill:#A2ABB1;" d="M66.8,111.9v57.9l50.1,28.9v-57.9C116.9,140.8,66.8,111.9,66.8,111.9z"
      />
    <g id="logo-connect">
      <path style="fill:#A2ABB1;" d="M1399.1,182.3c1,0,2,0.2,3,0.6s2,1,2.9,1.9l16.8,17.6c-7.3,9.6-16.5,16.8-27.6,21.7
        c-11,4.9-24.1,7.3-39.2,7.3c-13.8,0-26.2-2.4-37.2-7.1c-11-4.7-20.2-11.2-27.9-19.5c-7.6-8.3-13.5-18.1-17.6-29.5
        c-4.1-11.4-6.1-23.7-6.1-37.1c0-13.6,2.3-26.1,7-37.4c4.7-11.4,11.2-21.2,19.6-29.4s18.4-14.7,30.1-19.2
        c11.7-4.6,24.5-6.9,38.6-6.9c6.8,0,13.3,0.6,19.3,1.8c6,1.2,11.7,2.9,16.9,5s10.1,4.7,14.5,7.6c4.4,3,8.3,6.2,11.8,9.8l-14.2,19.1
        c-0.9,1.2-2,2.2-3.2,3.2c-1.2,1-3,1.4-5.2,1.4c-1.5,0-2.9-0.3-4.2-1c-1.3-0.7-2.8-1.5-4.2-2.4c-1.5-1-3.1-2-4.9-3.1
        c-1.8-1.1-3.9-2.2-6.4-3.1c-2.5-1-5.3-1.8-8.6-2.4c-3.3-0.7-7.1-1-11.6-1c-7.7,0-14.7,1.4-21,4.1c-6.3,2.7-11.8,6.6-16.3,11.6
        c-4.5,5-8.1,11.1-10.6,18.3c-2.5,7.2-3.8,15.2-3.8,24.1c0,9.3,1.3,17.6,3.8,24.9c2.5,7.2,6,13.4,10.4,18.3c4.4,5,9.5,8.7,15.3,11.3
        c5.8,2.6,12.1,3.9,18.8,3.9c3.8,0,7.3-0.2,10.5-0.6c3.2-0.4,6.1-1,8.8-1.9c2.7-0.9,5.3-2.1,7.8-3.6c2.5-1.5,4.9-3.3,7.4-5.4
        c1-0.8,2.1-1.5,3.2-2.1C1396.6,182.5,1397.8,182.3,1399.1,182.3z"/>
      <path style="fill:#A2ABB1;" d="M1502.4,97.8c9.8,0,18.8,1.5,26.9,4.6c8.1,3.1,15,7.5,20.8,13.2c5.8,5.8,10.3,12.7,13.5,20.9
        c3.2,8.2,4.8,17.4,4.8,27.7c0,10.3-1.6,19.6-4.8,27.9c-3.2,8.3-7.7,15.3-13.5,21.1c-5.8,5.8-12.7,10.2-20.8,13.4
        c-8.1,3.1-17,4.7-26.9,4.7c-9.9,0-18.9-1.6-27.1-4.7s-15.1-7.6-21-13.4c-5.9-5.8-10.4-12.8-13.6-21.1c-3.2-8.3-4.8-17.6-4.8-27.9
        c0-10.2,1.6-19.5,4.8-27.7c3.2-8.2,7.8-15.2,13.6-20.9s12.9-10.2,21-13.2C1483.5,99.3,1492.5,97.8,1502.4,97.8z M1502.4,202.7
        c8.9,0,15.5-3.1,19.7-9.4c4.2-6.3,6.3-15.9,6.3-28.7c0-12.8-2.1-22.4-6.3-28.6c-4.2-6.2-10.8-9.4-19.7-9.4
        c-9.2,0-15.9,3.1-20.1,9.4c-4.2,6.3-6.4,15.8-6.4,28.6c0,12.8,2.1,22.4,6.4,28.7C1486.6,199.5,1493.3,202.7,1502.4,202.7z"/>
      <path style="fill:#A2ABB1;" d="M1593.4,229.4V99.8h24c2.4,0,4.4,0.5,6.1,1.6c1.6,1.1,2.8,2.7,3.4,4.9l2.2,7.5
        c2.5-2.3,5.1-4.5,7.8-6.5c2.7-2,5.5-3.7,8.6-5.1c3-1.4,6.3-2.5,9.9-3.2c3.5-0.8,7.4-1.2,11.6-1.2c7.1,0,13.4,1.2,18.8,3.7
        c5.5,2.5,10.1,5.9,13.8,10.2s6.6,9.6,8.5,15.6c1.9,6,2.9,12.6,2.9,19.7v82.4h-38.8V147c0-6.3-1.5-11.3-4.4-14.8
        c-2.9-3.5-7.2-5.3-12.9-5.3c-4.2,0-8.2,0.9-12,2.8c-3.8,1.8-7.3,4.3-10.8,7.4v92.4H1593.4z"/>
      <path style="fill:#A2ABB1;" d="M1742.2,229.4V99.8h24c2.4,0,4.4,0.5,6.1,1.6c1.6,1.1,2.8,2.7,3.4,4.9l2.2,7.5
        c2.5-2.3,5.1-4.5,7.8-6.5c2.7-2,5.5-3.7,8.6-5.1c3-1.4,6.3-2.5,9.9-3.2c3.5-0.8,7.4-1.2,11.6-1.2c7.1,0,13.4,1.2,18.8,3.7
        c5.5,2.5,10.1,5.9,13.8,10.2s6.6,9.6,8.5,15.6c1.9,6,2.9,12.6,2.9,19.7v82.4h-38.8V147c0-6.3-1.5-11.3-4.4-14.8
        c-2.9-3.5-7.2-5.3-12.9-5.3c-4.2,0-8.2,0.9-12,2.8c-3.8,1.8-7.3,4.3-10.8,7.4v92.4H1742.2z"/>
      <path style="fill:#A2ABB1;" d="M1946.4,97.8c8.6,0,16.4,1.3,23.6,4c7.1,2.7,13.2,6.5,18.4,11.6c5.1,5.1,9.1,11.3,12,18.7
        c2.9,7.4,4.3,15.7,4.3,25.1c0,2.9-0.1,5.3-0.4,7.1c-0.2,1.8-0.7,3.3-1.4,4.4c-0.7,1.1-1.6,1.8-2.7,2.2c-1.1,0.4-2.6,0.6-4.3,0.6
        h-74.8c1.2,10.8,4.5,18.7,9.9,23.6c5.3,4.9,12.2,7.3,20.6,7.3c4.5,0,8.4-0.5,11.6-1.6c3.2-1.1,6.1-2.3,8.7-3.6
        c2.5-1.3,4.9-2.5,7-3.6c2.1-1.1,4.4-1.6,6.7-1.6c3.1,0,5.4,1.1,7,3.4l11.2,13.9c-4,4.6-8.3,8.3-12.9,11.2s-9.4,5.1-14.2,6.8
        s-9.8,2.8-14.6,3.4s-9.5,0.9-13.9,0.9c-9.1,0-17.6-1.5-25.6-4.4c-8-3-14.9-7.4-20.9-13.2c-6-5.8-10.7-13.1-14.1-21.8
        c-3.5-8.7-5.2-18.8-5.2-30.2c0-8.7,1.5-16.9,4.4-24.6c3-7.8,7.2-14.5,12.8-20.4c5.5-5.8,12.2-10.5,20.1-13.9
        C1927.6,99.5,1936.5,97.8,1946.4,97.8z M1947.2,124.5c-7.4,0-13.2,2.1-17.4,6.3c-4.2,4.2-6.9,10.3-8.2,18.2h48.4
        c0-3.1-0.4-6.1-1.2-9c-0.8-2.9-2.1-5.5-3.9-7.8c-1.8-2.3-4.1-4.1-7.1-5.6C1954.9,125.2,1951.4,124.5,1947.2,124.5z"/>
      <path style="fill:#A2ABB1;" d="M2124.2,130.5c-1.2,1.4-2.3,2.5-3.4,3.4c-1.1,0.8-2.6,1.2-4.6,1.2c-1.9,0-3.6-0.5-5.2-1.4
        c-1.5-0.9-3.3-1.9-5.2-3.1c-1.9-1.1-4.2-2.1-6.8-3.1c-2.6-0.9-5.8-1.4-9.6-1.4c-4.8,0-8.9,0.9-12.3,2.6c-3.5,1.8-6.3,4.2-8.6,7.5
        c-2.2,3.3-3.9,7.2-5,11.9c-1.1,4.7-1.6,10-1.6,15.9c0,12.4,2.4,22,7.2,28.6c4.8,6.7,11.4,10,19.8,10c4.5,0,8.1-0.6,10.7-1.7
        s4.9-2.4,6.7-3.8c1.8-1.4,3.5-2.6,5.1-3.8c1.5-1.2,3.5-1.8,5.8-1.8c3.1,0,5.4,1.1,7,3.4l11.2,13.9c-4,4.6-8.2,8.3-12.6,11.2
        c-4.4,2.9-8.9,5.1-13.6,6.8s-9.3,2.8-13.9,3.4c-4.7,0.6-9.2,0.9-13.6,0.9c-7.9,0-15.5-1.5-22.7-4.5c-7.2-3-13.5-7.4-19-13.1
        c-5.5-5.7-9.8-12.7-13-21.1c-3.2-8.3-4.8-17.8-4.8-28.5c0-9.3,1.4-18.1,4.2-26.2c2.8-8.1,6.9-15.2,12.4-21.1
        c5.5-6,12.2-10.6,20.2-14.1c8-3.4,17.4-5.1,27.9-5.1c10.2,0,19.1,1.6,26.8,4.9c7.7,3.2,14.6,8,20.8,14.2L2124.2,130.5z"/>
      <path style="fill:#A2ABB1;" d="M2201.4,231.4c-6.2,0-11.6-0.9-16.3-2.7c-4.7-1.8-8.7-4.3-11.9-7.6c-3.2-3.3-5.6-7.3-7.3-11.9
        c-1.7-4.7-2.5-9.9-2.5-15.6v-67h-11c-2,0-3.7-0.6-5.1-1.9c-1.4-1.3-2.1-3.2-2.1-5.7v-15.1l20.6-4l7.6-31.6c1-4,3.8-6,8.5-6h20.2
        V100h31.5v26.5h-31.5v64.4c0,3,0.7,5.5,2.2,7.4c1.5,2,3.6,2.9,6.3,2.9c1.4,0,2.6-0.1,3.6-0.4c1-0.3,1.8-0.6,2.5-1
        c0.7-0.4,1.4-0.7,2-1c0.6-0.3,1.4-0.4,2.2-0.4c1.2,0,2.1,0.3,2.8,0.8c0.7,0.5,1.4,1.4,2.2,2.6l11.8,18.4c-5,3.8-10.6,6.6-16.9,8.4
        S2208.1,231.4,2201.4,231.4z"/>
      <path style="fill:#A2ABB1;" d="M1212.7,209.8c0-3,0.6-5.8,1.7-8.4c1.1-2.6,2.7-4.8,4.6-6.8c2-1.9,4.3-3.4,6.9-4.6
        c2.7-1.1,5.6-1.7,8.8-1.7c3.1,0,6,0.6,8.6,1.7c2.7,1.1,5,2.6,7,4.6c2,1.9,3.6,4.2,4.7,6.8s1.7,5.4,1.7,8.4s-0.6,5.8-1.7,8.4
        s-2.7,4.9-4.7,6.8c-2,1.9-4.3,3.4-7,4.5s-5.5,1.6-8.6,1.6c-3.2,0-6.1-0.5-8.8-1.6c-2.7-1.1-5-2.6-6.9-4.5c-2-1.9-3.5-4.2-4.6-6.8
        S1212.7,212.8,1212.7,209.8z"/>
    </g>
  </svg>
</ng-template>

<ng-template #checkIcon>
  <!-- <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg> -->
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-square">
    <polyline points="9 11 12 14 22 4"></polyline>
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
  </svg>
</ng-template>

<ng-template #minusIcon>
  <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle text-secondary">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="8" y1="12" x2="16" y2="12"></line>
  </svg>
</ng-template>

<ng-template #questionIcon>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle">
    <circle cx="12" cy="12" r="10"></circle>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
</ng-template>